export default __webpack_public_path__ + "89d0fe6abb1e978b99fea6ad60896bbb.png";